import { render, staticRenderFns } from "./CountryLang.vue?vue&type=template&id=40c285f0&"
import script from "./CountryLang.vue?vue&type=script&lang=js&"
export * from "./CountryLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports